import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import * as service from '../../services/service';

function CaseDetails() {
    const [state, setState] = useState({
        caseno: '', noticeno: '', complainant: '', respondent: '', village: '', casesubject: '', remarks: ''
    });
    const [data, setData] = useState([]);
    const [civilIDCData, setCivilIDCData] = useState([]);
    const [civilCEOData, setCivilCEOData] = useState([]);
    const [civilSEOData, setCivilSEOData] = useState([]);
    const [civilDivisionData, setCivilDivisionData] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [civilIDCId, setCivilIDCId] = useState('');
    const [civilCEOId, setCivilCEOId] = useState('');
    const [civilSEOId, setCivilSEOId] = useState('');
    const [civilDivisionId, setCivilDivisionId] = useState('');
    const [projectId, setProjectId] = useState('');
    const [districtId, setDistrictId] = useState('');
    const [courtData, setCourtData] = useState([]);
    const [courtId, setCourtId] = useState('');
    const [caseTypeData, setCaseTypeData] = useState([]);
    const [caseTypeId, setCaseTypeId] = useState('');
    const [noticeDate, setNoticeDate] = useState(new Date());
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const navigate = useNavigate();
    // const userLvl = JSON.parse(sessionStorage.getItem('userData')).userLevel;

    const getCivilIDCs = () => {
        fetch(
            service.CIVILIDC_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilIDCId, label: item.civilIDC }));
                setCivilIDCData(data2);
            });
    };

    const getCivilCEOs = (id) => {
        fetch(
            service.GET_CIVILCEO_BY_IDC_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilIDCId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilCEOId, label: item.civilCEO }));
                setCivilCEOData(data2);
            });
    };

    const getCivilSEOs = (id) => {
        fetch(
            service.GET_CIVILSEO_BY_CEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilCEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilSEOId, label: item.civilSEO }));
                setCivilSEOData(data2);
            });
    };

    const getCivilDivisions = (id) => {
        fetch(
            service.GET_CIVIL_DIVISION_BY_SEO_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilSEOId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.civilDivisionId, label: item.civilDivision }));
                setCivilDivisionData(data2);
            });
    };

    const getDistricts = () => {
        fetch(
            service.DISTRICTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.districtId, label: item.district }));
                setDistrictData(data2);
            });
    };

    const getCourts = () => {
        fetch(
            service.COURTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.courtId, label: item.court }));
                setCourtData(data2);
            });
    };

    const getCaseTypes = (id) => {
        fetch(
            service.GET_CASE_TYPE_BY_COURT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CourtId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseTypeId, label: item.caseType }));
                setCaseTypeData(data2);
            });
    };

    const getProjects = (divId) => {
        const errs = {};
        fetch(
            service.PROJECT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CivilDivisionId: divId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.projectId, label: item.project }));
                setProjectData(data2);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetails = (id) => {
        const errs = {};
        fetch(
            service.GET_CASE_DETAILS_BY_TYPE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseTypeId: id,
                    CivilIDCId: JSON.parse(sessionStorage.getItem('userData')).civilIDCId,
                    CivilCEOId: JSON.parse(sessionStorage.getItem('userData')).civilCEOId,
                    CivilSEOId: JSON.parse(sessionStorage.getItem('userData')).civilSEOId,
                    CivilDivisionId: JSON.parse(sessionStorage.getItem('userData')).civilDivisionId
                })
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getDetailsById = (id) => {
        setLoading(true);
        const errs = {};
        fetch(
            service.GET_CASE_DETAILS_BY_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === 'Success') {
                    setState({
                        ...state, caseno: result.caseNo, noticeno: result.noticeNo, complainant: result.complainant,
                        respondent: result.respondent, village: result.village, casesubject: result.caseSubject, remarks: result.remarks
                    });

                    const idcData = ({ value: result.civilIDCId, label: result.civilIDC });
                    setCivilIDCId(idcData);
                    getCivilCEOs(idcData.value);
                    const ceData = ({ value: result.civilCEOId, label: result.civilCEO });
                    setCivilCEOId(ceData);
                    getCivilSEOs(ceData.value);
                    const seData = ({ value: result.civilSEOId, label: result.civilSEO });
                    setCivilSEOId(seData);
                    getCivilDivisions(seData.value);
                    const divData = ({ value: result.civilDivisionId, label: result.civilDivision });
                    setCivilDivisionId(divData);
                    getProjects(divData.value);
                    const projData = ({ value: result.projectId, label: result.project });
                    setProjectId(projData);
                    const couData = ({ value: result.courtId, label: result.court });
                    setCourtId(couData);
                    getCaseTypes(couData.value);
                    const typeData = ({ value: result.caseTypeId, label: result.caseType });
                    setCaseTypeId(typeData);
                    const disData = ({ value: result.districtId, label: result.district });
                    setDistrictId(disData);
                    setNoticeDate(new Date(result.noticeDate));
                }
                else {
                    errs[".invalid"] = result.message.message;
                    setErrors(errs);
                }
            });
        setLoading(false);
    };
    const handleEdit = (id) => {
        getDetailsById(id);
        localStorage.setItem("ID", JSON.stringify(id));
    }
    const handleStage = (id) => {
        navigate(`/casestagedetails/${id}`);
    }

    useEffect(() => {
        setLoading(true);
        getDistricts();
        getCourts();
        getCivilIDCs();
        const cc = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilIDC, value: JSON.parse(sessionStorage.getItem('userData')).civilIDCId });
        setCivilIDCId(cc);
        getCivilCEOs(cc.value);
        const ceo = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilCEO, value: JSON.parse(sessionStorage.getItem('userData')).civilCEOId });
        setCivilCEOId(ceo);
        getCivilSEOs(ceo.value);
        const seo = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilSEO, value: JSON.parse(sessionStorage.getItem('userData')).civilSEOId });
        setCivilSEOId(seo);
        getCivilDivisions(seo.value);
        const div = ({ label: JSON.parse(sessionStorage.getItem('userData')).civilDivision, value: JSON.parse(sessionStorage.getItem('userData')).civilDivisionId });
        setCivilDivisionId(div);
        getProjects(div.value);
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!civilDivisionId) {
            isValid = false;
            errs[".civilDivisionId"] = "Please select Civil Division";
        }
        if (!projectId) {
            isValid = false;
            errs[".project"] = "Please select Project";
        }
        if (!districtId) {
            isValid = false;
            errs[".districtId"] = "Please select District";
        }
        if (!caseTypeId) {
            isValid = false;
            errs[".caseTypeId"] = "Please select Case Type";
        }
        if (!state.caseno) {
            isValid = false;
            errs[".caseno"] = "Please enter Case No";
        }
        if (!state.complainant) {
            isValid = false;
            errs[".complainant"] = "Please enter Complainant";
        }
        if (!state.respondent) {
            isValid = false;
            errs[".respondent"] = "Please enter Respondent";
        }
        setErrors(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const CourtChangeHandler = (ev) => {
        setCourtId(ev);
        setCaseTypeId(null);
        setData([]);
        getCaseTypes(ev.value);
    }
    const CaseTypeChangeHandler = (ev) => {
        setCaseTypeId(ev);
        getDetails(ev.value);
    }
    const CivilIDCChangeHandler = (ev) => {
        setCivilIDCId(ev);
        getCivilCEOs(ev.value);
    }

    const CivilCEOChangeHandler = (ev) => {
        setCivilCEOId(ev);
        getCivilSEOs(ev.value);
    }
    const CivilSEOChangeHandler = (ev) => {
        setCivilSEOId(ev);
        setCivilDivisionData([]);
        getCivilDivisions(ev.value);
    }
    const CivilDivisionChangeHandler = (ev) => {
        setCivilDivisionId(ev);
        getProjects(ev.value);
    }
    const ProjectChangeHandler = (ev) => {
        setProjectId(ev);
    }
    const DistrictChangeHandler = (ev) => {
        setDistrictId(ev);
    }

    const clearHandler = () => {
        localStorage.setItem('ID', null);
        setState({
            ...state, caseno: '', noticeno: '', complainant: '', respondent: '', village: '', casesubject: '', remarks: ''
        });
        // const idc = ({ value: null, label: "Select Civil IDC" });
        // setCivilIDCId(idc);
        // const ceo = ({ value: null, label: "Select Civil CEO" });
        // setCivilCEOId(ceo);
        // const seo = ({ value: null, label: "Select Civil SEO" });
        // setCivilSEOId(seo);
        // const div = ({ value: null, label: "Select Civil Division" });
        // setCivilDivisionId(div);
        const proj = ({ value: null, label: "Select Project" });
        setProjectId(proj);
        const dis = ({ value: null, label: "Select District" });
        setDistrictId(dis);
        setData([]);
    }

    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_CASE_DETAILS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CaseId: JSON.parse(localStorage.getItem('ID')) !== null ? JSON.parse(localStorage.getItem('ID')) : 0,
                        CourtId: courtId.value,
                        CaseTypeId: caseTypeId.value,
                        CaseNo: state.caseno,
                        NoticeNo: state.noticeno,
                        NoticeDate: moment(noticeDate).format("MM/DD/YYYY"),
                        Complainant: state.complainant,
                        Respondent: state.respondent,
                        DistrictId: districtId.value,
                        Village: state.village,
                        ProjectId: projectId.value,
                        CaseSubject: state.casesubject,
                        Remarks: state.remarks,
                        CivilIDCId: civilIDCId.value,
                        CivilCEOId: civilCEOId.value,
                        CivilSEOId: civilSEOId.value,
                        CivilDivisionId: civilDivisionId.value,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        localStorage.setItem('ID', null);
                        // window.location.reload();
                        setState({ ...state, caseno: '', noticeno: '', complainant: '', respondent: '', village: '', casesubject: '', remarks: '' });
                        getDetails(caseTypeId.value);
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        errs[".invalid"] = result.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Case Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell width="45%">
                                                <Select
                                                    name="Civil IDC"
                                                    options={civilIDCData} placeholder="Select Civil IDC"
                                                    value={civilIDCId}
                                                    onChange={CivilIDCChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilIDCId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil CEO"
                                                    options={civilCEOData} placeholder="Select Civil CEO"
                                                    value={civilCEOId}
                                                    onChange={CivilCEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilCEOId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Civil SEO"
                                                    options={civilSEOData} placeholder="Select Civil SEO"
                                                    value={civilSEOId}
                                                    onChange={CivilSEOChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilSEOId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Civil Division"
                                                    options={civilDivisionData} placeholder="Select Civil Division"
                                                    value={civilDivisionId}
                                                    onChange={CivilDivisionChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".civilDivisionId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Court"
                                                    options={courtData} placeholder="Select Court"
                                                    value={courtId}
                                                    onChange={CourtChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".courtId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <Select
                                                    name="Case Type"
                                                    options={caseTypeData} placeholder="Select Case Type"
                                                    value={caseTypeId}
                                                    onChange={CaseTypeChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseTypeId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="Project"
                                                    options={projectData} placeholder="Select Project"
                                                    value={projectId}
                                                    onChange={ProjectChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".project"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Case No" fullWidth value={state.caseno || ''}
                                                    name="caseno"
                                                    onChange={changeHandler}
                                                    id="caseno"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseno"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Notice No" fullWidth value={state.noticeno || ''}
                                                    name="noticeno"
                                                    onChange={changeHandler}
                                                    id="noticeno"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".noticeno"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                Notice Date
                                                <DatePicker
                                                    id="noticeDate"
                                                    selected={noticeDate}
                                                    onChange={date => setNoticeDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".noticeDate"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Complainant" fullWidth value={state.complainant || ''}
                                                    name="complainant"
                                                    onChange={changeHandler}
                                                    id="complainant"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".complainant"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Respondent" fullWidth value={state.respondent || ''}
                                                    name="respondent"
                                                    onChange={changeHandler}
                                                    id="respondent"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".respondent"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <Select
                                                    name="District"
                                                    options={districtData} placeholder="Select District"
                                                    value={districtId}
                                                    onChange={DistrictChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".districtId"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Village" fullWidth value={state.village || ''}
                                                    name="village"
                                                    onChange={changeHandler}
                                                    id="village"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".village"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Case Subject" fullWidth value={state.casesubject || ''}
                                                    name="casesubject"
                                                    onChange={changeHandler}
                                                    id="casesubject"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".casesubject"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDInput label="Remarks" fullWidth value={state.remarks || ''}
                                                    name="remarks"
                                                    onChange={changeHandler}
                                                    id="remarks"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".remarks"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                CLEAR
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>

                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">

                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Notice No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Notice Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Complainant</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Respondent</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Project</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Subject</TableCell>
                                                <TableCell colSpan="2" align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow
                                                        key={row.caseId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.caseNo}</TableCell>
                                                        <TableCell>{row.noticeNo}</TableCell>
                                                        <TableCell>{moment(row.noticeDate).format('DD/MM/YYYY')}</TableCell>
                                                        <TableCell>{row.complainant}</TableCell>
                                                        <TableCell>{row.respondent}</TableCell>
                                                        <TableCell>{row.project}</TableCell>
                                                        <TableCell>{row.caseSubject}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleEdit(row.caseId)}>Edit</MDButton></TableCell>
                                                        <TableCell><MDButton onClick={() => handleStage(row.caseId)}>Add Stage</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default CaseDetails;